import React, { useEffect, useState } from "react";
import Client from "../../Assets/Images/client.svg";
import Token from "../../Assets/Images/Token.svg";
import { Link, useNavigate } from "react-router-dom";
const CompletedClients = ({ heading, data, completedDate }) => {
  const [sortedData, setSortedData] = useState([data]);
  const navigate = useNavigate();

  useEffect(() => {
    setSortedData(data);
  }, [data]);
  
  useEffect(() => {
    if (completedDate) {
      console.log('Completed clients date:', completedDate);
    }
  }, [completedDate])

  const handleArrowClick = (id) => {
    const clientData = sortedData.find((client) => client.id === id);
    navigate(`/added-client/${id}`, { state: { client: clientData } });
  };

  console.log('client-data', data)

  return (
    <div className="client-table-container completed-clients">
      <div className="table-heading">{heading}</div>
      <div className="project-table">

        {Array.isArray(data) && data.length > 0 ?
          <table className="table" style={{ tableLayout: "fixed", width: "100%" }}>
            <colgroup>
              <col style={{ width: "5%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "15%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "10%" }} />
            </colgroup>
            <thead className="table-header">
              <tr>
                <th className="header-cell"></th>
                <th className="header-cell">Client Name</th>
                <th className="header-cell">Company Name</th>
                <th className="header-cell">Group ID</th>
                <th className="header-cell center-align">Assessments</th>
                <th className="header-cell center-align">End Date</th>
                <th className="header-cell">Start Date</th>
                {/* <th className="header-cell"></th> */}
              </tr>
            </thead>
            <tbody className="table-body">
              {data?.map((client, index) => (
                <tr key={client.id} className="table-row" onClick={() => handleArrowClick(client.id)}>
                  <td className="cell order-number">{index + 1}.</td>
                  <td className="cell client-name">{client?.name || client?.title}</td>
                  <td className="cell">{client?.company}</td>
                  <td className="cell">{client?.groupid}</td>
                  <td className="cell center-align">{client?.respondents}</td>
                  <td className="cell center-align">
                  {completedDate
                    ? (() => {
                      const date = new Date(completedDate);
                      const month = date.toLocaleString("en-US", { month: "short" });
                      const day = String(date.getDate()).padStart(2, "0");
                      const year = date.getFullYear();
                      return `${month} ${day} ${year}`;
                    })()
                  : ""}
                  </td>
                  <td className="cell date-column seven">
                    {client?.created_at
                      ? (() => {
                        const date = new Date(client.created_at);
                        const month = date.toLocaleString("en-US", { month: "short" });
                        const day = date.getDate();
                        const year = date.getFullYear();
                        return `${month} ${day} ${year}`;
                      })()
                    : ""}
                  </td>
                  {/* <td style={{ marginLeft: "10px", cursor: "pointer" }} className="arrow">
                    &gt;
                  </td> */}
                </tr>
              ))
              }

              <tr className="table-row">
                <td className="cell"></td>
              </tr>
            </tbody>
          </table>
          :
          <>
            {/* <div className="table-header no-clients">
              <div className="header-cell one"></div>
              <div className="header-cell two">Client Name</div>
              <div className="header-cell three">Company Name</div>
              <div className="header-cell four">Group ID</div>
              <div className="header-cell five">Assessments</div>
              <div className="header-cell six">Completion</div>
              <div className="header-cell seven">Start Date</div>
            </div>
            <div className="table-dashboard-container no-clients">
              <div className="table-row example-word opacity-class">
                <div className="cell-example order-number one"></div>
                <div className="cell-example client-name  two">Example</div>
                <div className="cell-example three"></div>
                <div className="cell-example four"></div>
                <div className="cell-example five"></div>
                <div className="cell-example six"></div>
                <div className="cell-example date-column seven"></div>
                <div></div>
              </div>
              <div className="table-row table-row-example opacity-class">
                <div className="cell-example order-number one"> 1.</div>
                <div className="cell-example client-name  two">Bruce Wayne</div>
                <div className="cell-example three">Wayne</div>
                <div className="cell-example four">Wayne007</div>
                <div className="cell-example five"> 7</div>
                <div className="cell-example six">
                  <div className="completion">
                    <span> {5}/ {7} </span>
                    <div className="progress-bar">
                      <div className="progress" style={{ width: `${5 / 7 * 100}%`, }} ></div>
                    </div>
                  </div>
                </div>
                <div className="cell date-column seven">
                  7 Jan 2024
                </div>
                <div></div>
              </div>
              <div className="client-section opacity-class">
                <span className="line1">You have no clients added yet.</span>
                <span className="line2">
                  <u>Add a client</u> to get started.
                </span>
              </div>

              <div className="inner-section">
                <div className="text">Get started</div>
                <div className="second-section">
                  <div className="Add-client">
                    <Link to="/add-client" className="link">
                      <img src={Client} alt="" style={{ marginLeft: "22px" }} />
                      <span>Add Clients</span>
                    </Link>
                  </div>
                  <div className="divider">
                    <div className="line"></div>
                    <span className="or-text">or</span>
                    <div className="line"></div>
                  </div>
                  <div className="buy-token">
                    <Link to="/tokens" className="link">
                      <img src={Token} alt="" style={{ marginLeft: "22px" }} />
                      <span>Buy Tokens</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div> */}
          </>
        }
      </div>

    </div>
  );
};

export { CompletedClients };
